/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Simple mobile menu toggle handler
(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('[data-action="toggle-menu"]');
    var mobileMenu = document.querySelector('#mobile-menu');
    
    if (!toggleButton || !mobileMenu) {
      return;
    }
    
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      var isHidden = mobileMenu.getAttribute('aria-hidden') === 'true';
      
      if (isHidden) {
        // Opening menu
        mobileMenu.setAttribute('aria-hidden', 'false');
        toggleButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('no-mobile-scroll');
        
        // Set max height
        var header = document.querySelector('.header');
        if (header) {
          var headerBottom = header.getBoundingClientRect().bottom;
          mobileMenu.style.maxHeight = (window.innerHeight - headerBottom) + 'px';
        }
      } else {
        // Closing menu
        mobileMenu.setAttribute('aria-hidden', 'true');
        toggleButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('no-mobile-scroll');
        mobileMenu.style.maxHeight = '';
      }
    });
  });
})();
